export const authTypes = {
  LOGIN: 'login',
  SIGNUP: 'signup',
}
